"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Messages = require("../../codegen/Messages");
var __1 = require("../../");
var types_1 = require("./types");
var CellWidth;
(function (CellWidth) {
    CellWidth["OneHalf"] = "oui-width-1-2";
    CellWidth["OneThird"] = "oui-width-1-3";
    CellWidth["TwoThirds"] = "oui-width-2-3";
    CellWidth["OneQuarter"] = "oui-width-1-4";
    CellWidth["ThreeQuarters"] = "oui-width-3-4";
    CellWidth["OneFifth"] = "oui-width-1-5";
    CellWidth["TwoFifths"] = "oui-width-2-5";
    CellWidth["ThreeFifths"] = "oui-width-3-5";
    CellWidth["FourFifths"] = "oui-width-4-5";
    CellWidth["OneSixth"] = "oui-width-1-6";
    CellWidth["FiveSixths"] = "oui-width-5-6";
    CellWidth["OneHalfS"] = "oui-width-1-2@s";
    CellWidth["OneThirdS"] = "oui-width-1-3@s";
    CellWidth["TwoThirdsS"] = "oui-width-2-3@s";
    CellWidth["OneQuarterS"] = "oui-width-1-4@s";
    CellWidth["ThreeQuartersS"] = "oui-width-3-4@s";
    CellWidth["OneFifthS"] = "oui-width-1-5@s";
    CellWidth["TwoFifthsS"] = "oui-width-2-5@s";
    CellWidth["ThreeFifthsS"] = "oui-width-3-5@s";
    CellWidth["FourFifthsS"] = "oui-width-4-5@s";
    CellWidth["OneSixthS"] = "oui-width-1-6@s";
    CellWidth["FiveSixthsS"] = "oui-width-5-6@s";
    CellWidth["OneHalfM"] = "oui-width-1-2@m";
    CellWidth["OneThirdM"] = "oui-width-1-3@m";
    CellWidth["TwoThirdsM"] = "oui-width-2-3@m";
    CellWidth["OneQuarterM"] = "oui-width-1-4@m";
    CellWidth["ThreeQuartersM"] = "oui-width-3-4@m";
    CellWidth["OneFifthM"] = "oui-width-1-5@m";
    CellWidth["TwoFifthsM"] = "oui-width-2-5@m";
    CellWidth["ThreeFifthsM"] = "oui-width-3-5@m";
    CellWidth["FourFifthsM"] = "oui-width-4-5@m";
    CellWidth["OneSixthM"] = "oui-width-1-6@m";
    CellWidth["FiveSixthsM"] = "oui-width-5-6@m";
    CellWidth["OneHalfL"] = "oui-width-1-2@l";
    CellWidth["OneThirdL"] = "oui-width-1-3@l";
    CellWidth["TwoThirdsL"] = "oui-width-2-3@l";
    CellWidth["OneQuarterL"] = "oui-width-1-4@l";
    CellWidth["ThreeQuartersL"] = "oui-width-3-4@l";
    CellWidth["OneFifthL"] = "oui-width-1-5@l";
    CellWidth["TwoFifthsL"] = "oui-width-2-5@l";
    CellWidth["ThreeFifthsL"] = "oui-width-3-5@l";
    CellWidth["FourFifthsL"] = "oui-width-4-5@l";
    CellWidth["OneSixthL"] = "oui-width-1-6@l";
    CellWidth["FiveSixthsL"] = "oui-width-5-6@l";
    CellWidth["OneHalfXL"] = "oui-width-1-2@xl";
    CellWidth["OneThirdXL"] = "oui-width-1-3@xl";
    CellWidth["TwoThirdsXL"] = "oui-width-2-3@xl";
    CellWidth["OneQuarterXL"] = "oui-width-1-4@xl";
    CellWidth["ThreeQuartersXL"] = "oui-width-3-4@xl";
    CellWidth["OneFifthXL"] = "oui-width-1-5@xl";
    CellWidth["TwoFifthsXL"] = "oui-width-2-5@xl";
    CellWidth["ThreeFifthsXL"] = "oui-width-3-5@xl";
    CellWidth["FourFifthsXL"] = "oui-width-4-5@xl";
    CellWidth["OneSixthXL"] = "oui-width-1-6@xl";
    CellWidth["FiveSixthsXL"] = "oui-width-5-6@xl";
})(CellWidth = exports.CellWidth || (exports.CellWidth = {}));
var SortDirection;
(function (SortDirection) {
    /**
     * Sort from small to large values.
     */
    SortDirection["Asc"] = "ascending";
    /**
     * Sort from large to small values.
     */
    SortDirection["Desc"] = "descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
exports.invert = function (sortDirection) {
    return (sortDirection &&
        (sortDirection === SortDirection.Asc
            ? SortDirection.Desc
            : SortDirection.Asc));
};
// Keycodes that trigger sort when the header is sortable and focused
var validKeyCodes = [13, 32]; // enter, spacebar
var THeaderCell = /** @class */ (function (_super) {
    __extends(THeaderCell, _super);
    function THeaderCell(props) {
        var _this = _super.call(this, props) || this;
        _this.sort = _this.sort.bind(_this);
        return _this;
    }
    THeaderCell.prototype.sort = function (e) {
        var _a = this.props, sortDirection = _a.sortDirection, sortHandler = _a.sortHandler;
        if (e.type === "keydown" &&
            !validKeyCodes.includes(e.keyCode)) {
            return;
        }
        e.preventDefault();
        sortHandler(sortDirection);
    };
    THeaderCell.prototype.render = function () {
        var _a = this.props, children = _a.children, width = _a.width, _b = _a.borderLeft, borderLeft = _b === void 0 ? true : _b, iconText = _a.iconText, defaultSortDirection = _a.defaultSortDirection, sortDirection = _a.sortDirection, sortHandler = _a.sortHandler, disabled = _a.disabled, type = _a.type, rest = __rest(_a, ["children", "width", "borderLeft", "iconText", "defaultSortDirection", "sortDirection", "sortHandler", "disabled", "type"]);
        // The header is sortable if it has a sort handler and is not disabled... there is an important distinction between
        // the two - disabled with sort handler means we should render the icon, but invisible, so that it reserves space
        // and doesn't cause a jump when enabled (visible) again; no sort handler means that we never render the icon
        var hasSortHandler = !!sortHandler;
        var isSortable = hasSortHandler && !disabled;
        var isSorted = !!sortDirection;
        var sortDesc = (isSorted && sortDirection === SortDirection.Desc) ||
            (!isSorted && defaultSortDirection === SortDirection.Desc);
        var ariaSort = isSortable && isSorted ? (sortDesc ? "descending" : "ascending") : "none";
        var thProps = __assign({}, rest, { className: classNames(width, {
                "oui-border-left": borderLeft,
                "oui-cursor-pointer oui-visible-toggle": isSortable,
                "oui-table__cell--number": type === types_1.DataCellTypes.Number
            }) }, (isSortable && {
            "aria-sort": ariaSort,
            tabIndex: 0,
            onClick: this.sort,
            onKeyDown: this.sort,
            onMouseDown: function (e) {
                return e.preventDefault();
            } // Prevent mouse focus
        }), { scope: "col" });
        var iconClassName = classNames("oui-text-top", "oui-position-center-right", {
            "oui-invisible-hover oui-text-muted": isSortable && !isSorted,
            "oui-invisible": !isSortable // If sort handler but disabled, render invisible to reserve icon space
        });
        var ariaLabelProp = iconText || sortDesc
            ? Messages.Table.sortDescending()
            : Messages.Table.sortAscending();
        var icon = hasSortHandler && ( // Only render the icon if there is a sort handler
        React.createElement(__1.IconElement, { icon: sortDesc ? __1.Icon.TriangleDown : __1.Icon.TriangleUp, label: ariaLabelProp, ariaLabel: ariaLabelProp, className: iconClassName }));
        return (React.createElement("th", __assign({}, thProps),
            React.createElement("span", { className: "oui-position-relative oui__header-cell-carrot" },
                React.createElement("span", { className: classNames({
                        "oui-margin-medium-right": hasSortHandler
                    }) }, children),
                icon)));
    };
    return THeaderCell;
}(React.Component));
exports.default = THeaderCell;
//# sourceMappingURL=THeaderCell.js.map